import React, { useEffect, useRef, useState } from 'react';
import { Ads, AdsPreview, Post as PostType } from '../../types';
import ImgProfilePost from '../../components/Post/ImgProfilePost';
import UserName from '../../components/Post/UserName';
import PinPost from '../../components/Post/Config/Pin';
import ShareProfile from '../../components/Post/Config/ShareProfile/ShareProfile';
import BlockUser from '../../components/Post/Config/BlockUser';
import PostActions from '../../components/Post/EditAndDelete';
import Report from '../../components/Post/Config/Report';
import ImgPost from '../../components/Post/ImgPost/ImgPost';
import OptionsPost from '../../components/Post/OptionsPost';
import ImgVerified from '../../components/imgVerified/ImgVerified';
import { Edit, Heart, MessageCircle, Paperclip, Repeat, Send } from 'react-feather';
import { Bookmark, ChartArea, Keyboard, Megaphone } from 'lucide-react';
import { BUCKET_PACOCA_URL } from '../../global-components/src/utils/vars';
import { censorText, clearText } from '../../global-components/src/utils/text';
import IncreaseLimit from './increase-limit';
import { Link, useNavigate } from 'react-router-dom';

interface PostProps {
    ads: Ads;
    numbers: number | null;
}

const Ad: React.FC<PostProps> = ({ ads, numbers = 100 }) => {
    const [processedText, setProcessedText] = useState<string>(ads?.post?.text?.trim() ? clearText(censorText(ads?.post?.text)) : "");
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const [canExpand, setCanExpand] = useState<boolean>(false);
    const navigate = useNavigate();
    const textRef = useRef<HTMLParagraphElement>(null);
    var img = ads?.post?.user?.img_account ?  ads?.post?.user.img_account.replace(/\.\.\//g, '') : "/img/img-account.png";

    useEffect(() => {
        setProcessedText(ads?.post?.text ? clearText(censorText(ads?.post?.text)) : "");
    }, [ads?.post?.text]);

    useEffect(() => {
        if (textRef.current) {
            const realHeight = textRef.current.scrollHeight;
            const maxHeight = 100; // Mesmo valor de maxHeight do CSS
            // Verifica se o resultado final é apenas um emoji (img tag)
            const onlyEmoji = processedText.trim().match(/^<img[^>]*class=['"]emoji['"][^>]*>$/);
            setCanExpand(realHeight > (maxHeight + 100) && !onlyEmoji);
        }
    }, [ads?.post?.text]);

    return (
        <div>
            <div className="card card-post-preview card-post">
                <div className="row row-post" style={{ flexWrap: "nowrap" }}>
                    <div className="row row-inside-post">
                        <div className="col-2 col-img-account-post img-list-chat img-account-search" style={{cursor: "pointer"}}>
                            <img className="user-select-none img-account-post" src={`${BUCKET_PACOCA_URL}/${img}`} alt="" onError={(e) => { e.currentTarget.src = "/img/img-account.png"; }}  />
                        </div>

                        <div className="col col-post col-post-not-community" style={{ cursor: "pointer" }}>
                            <h2 onClick={(e) => e.stopPropagation()} className="cursor-pointer">
                                <Link to={"#"} className="link-name">{ads.post?.user?.name}</Link>
                                <ImgVerified user={ads?.post?.user} classNameProp="user-select-none img-verificado-comentario" />
                            </h2>

                            <p className='text-date-post'>anúncio</p>

                    <div className="col-1 col-conf-post">
                        <div className="dropdown">
                            <button
                                aria-label="Configuração do POST"
                                style={{ border: 0, borderRadius: "5px", background: "var(--background-post)" }}
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="25"
                                    height="25"
                                    fill="currentColor"
                                    className="svg-icons-color bi bi-three-dots svg-edit"
                                    viewBox="0 0 16 16"
                                >
                                    <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                </svg>
                            </button>
                                <ul className="dropdown-menu menu-drop" style={{ minWidth: "250px" }}>
                                    <li>
                                        <span className="dropdown-item cursor-pointer user-select-none" onClick={() => navigate(`/post/${ads.id_post}`)}>
                                            <div className="div-icon-fix">
                                                <Keyboard data-feather="paperclip" data-type="fix" className="icon-config-post"/> Visualizar Post
                                            </div> 
                                        </span>
                                    </li>
                                    {ads.status == "off" && (
                                        <li>
                                            <span className="dropdown-item cursor-pointer user-select-none" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#increase-limits">
                                                <div className="div-icon-fix">
                                                    <Megaphone data-feather="paperclip" data-type="fix" className="icon-config-post"/> Anúnciar novamente
                                                </div> 
                                            </span>
                                        </li>
                                    )}
                                </ul>
                        </div>
                    </div>
                    </div>

                        {processedText && (
                            <div
                                style={{ maxHeight: !isExpanded ? "200px" : "none", overflow: "hidden" }}
                                className={`row row-text-post ${canExpand ? "cursor-pointer" : ""}`}
                                onClick={() => canExpand && setIsExpanded(!isExpanded)}
                            >
                                <p
                                    ref={textRef}
                                    className="text-post post text-expand"
                                    dangerouslySetInnerHTML={{ __html: processedText }}
                                />

                                {!isExpanded && canExpand && (
                                    <span
                                        className="point-post"
                                    >
                                        <span>Ler mais</span>
                                    </span>
                                )}
                            </div>
                        )}

                        {ads?.post?.images ? (
                            <ImgPost img_account={ads.post?.user?.img_account} onLike={() => {}} images={ads.post?.images} post={ads.post} />
                        ) : null }


                        <div className="space-button-ads">
                            <div>
                                {ads.price && ads.price != "0,00" ? (
                                    <>R${ads.price}</>
                                ) : null}

                            </div>
                            <button className='btn btn-ads btn-light'>
                                <MessageCircle/>
                                {ads.button_text}
                            </button>
                        </div>



                        <div className="row row-info-post user-select-none">
                            <div className='d-flex' style={{ width: "auto" }}>
                                <div className="col-a">
                                    <div className="user-select-none button-like col-icon-post col col-like">
                                        <Heart className={`icon-post ${false ? "like-red" : ""}`} style={{ fill: false ? "red" : "" }} />
                                        <span style={{ minWidth: 12,  marginLeft: 3, paddingRight: 10, cursor: numbers && numbers > 0 ? "pointer" : "" }}>{ads.status ? ads.post.total_likes : numbers}</span>
                                    </div>
                                </div>
                
                                <div className="col-a">
                                    <div className="user-select-none button-comment col col-like col-icon-post">
                                        <MessageCircle className="icon-post" data-feather="message-circle" />
                                        <span style={{ minWidth: 12,  marginLeft: 3, paddingRight: 10, cursor: numbers && numbers > 0 ? "pointer" : "" }}>{ads.status ? ads.post.total_comments : numbers}</span>
                                    </div>
                                </div>
                
                                <div className="col-a">
                                    <div className="col" id="dropdownMenuButton" data-bs-toggle="dropdown" style={{ margin: 0, padding: 0 }}>
                                        <div className="dropdown col col-like col-icon-post">
                                            <Repeat className="icon-post" data-feather="repeat" id="dropdownMenuButton" data-bs-toggle="dropdown" />
                                            <span style={{ minWidth: 12,  marginLeft: 3, paddingRight: 10, cursor: numbers && numbers > 0 ? "pointer" : "" }}>{ads.status ? ads.post.total_shares : numbers}</span>

                                            <ul className="dropdown-menu dropdown-repost menu-drop" aria-labelledby="dropdownMenuButton">
                                                <li><a className="dropdown-item" href="#" id="btn-repost-with-text-modal" style={{ alignItems: "center" }}>
                                                    <Edit className="icon-repost" data-feather="edit" /> Escrever Publicação
                                                </a>
                                                </li>
                                                <li>
                                                    <a className="dropdown-item" href="#" style={{ alignItems: "center" }}>
                                                        <Repeat className="icon-repost" data-feather="repeat" />
                                                        Repostar Agora
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-a">
                                    <div className="user-select-none button-comment col col-like col-icon-post">
                                        <Bookmark className={`icon-post`} />
                                        <span style={{ minWidth: 12,  marginLeft: 3, paddingRight: 10, cursor: numbers && numbers > 0 ? "pointer" : "" }}>{ads.status ? ads.post.total_saved : numbers}</span>
                                    </div>
                                </div>
                
                                <div className="col-a">
                                    <div className="dropdown col col-like col-icon-post">
                                        <Send className="icon-post" data-feather="send" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Ad;
